unit Essentials.Web.Attributes.EditAttributeValueForm;

interface

uses
  {$IFNDEF PAS2JS}
  Winapi.Windows, Winapi.Messages,
  {$ENDIF}
  System.SysUtils, {$IFNDEF PAS2JS}System.Variants,{$ENDIF} System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WEBLib.Forms, Essentials.Web.BaseEditForm, Data.DB,
  WEBLib.DB, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.ExtCtrls, Essentials.Web.Shared,
  XData.Web.Dataset, Essentials.Web.Attributes.Validation;

type
  TEditAttributeValue = class(TEssentialsBaseEditForm)
    AttributeSelector: TDBLookupComboBox;
    AttributesValueEdit: TDBEdit;
    ValidationsLabel: TLabel;
    procedure CancelButtonClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure EditButtonClick(Sender: TObject);
    procedure AttributeSelectorChange(Sender: TObject);
  private
    FValidator: TAttributesValidator;
    FDataset: TXDataWebDataset;
    procedure SetEditMode(const Value: TEditMode); override;
    function Validate: Boolean;
  protected
    function AllRequiredFieldsAreSet: Boolean; override;
  public
    { Public declarations }
    procedure SetDataSources(aAttributeDataset: TXDataWebDataset; aDefinitionSource: TDataSource); overload;
    property Validator: TAttributesValidator write FValidator;
  protected procedure LoadDFMValues; override; end;

var
  EditAttributeValue: TEditAttributeValue;

implementation

uses
XData.Web.JsonDataset, XData.Dataset.Utils, Crud.Utils,
Systematic.ObjectDictionary.Utils;

{$R *.dfm}

{ TEditAttributeValue }

function TEditAttributeValue.AllRequiredFieldsAreSet: Boolean;
begin
  Result := AttributeSelector.ItemIndex > -1;
end;

procedure TEditAttributeValue.AttributeSelectorChange(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TEditAttributeValue.CancelButtonClick(Sender: TObject);
begin
  ValidationsLabel.Visible := False;
  inherited;
end;

procedure TEditAttributeValue.EditButtonClick(Sender: TObject);
begin
  if FEditMode <> None then
  begin
    if Validate then
      ModalResult := mrOK;
  end
  else
    SetEditMode(Edit);
end;

procedure TEditAttributeValue.SetDataSources(
  aAttributeDataset: TXDataWebDataset; aDefinitionSource: TDataSource);
begin
  SetDataSources(aAttributeDataset);
  AttributeSelector.ListSource := aDefinitionSource;
  DataSource.AutoEdit := False;
end;

procedure TEditAttributeValue.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    AttributesValueEdit.Enabled := True;
    AttributeSelector.Enabled := True;
    AttributesValueEdit.SetFocus;
  end;
end;

function TEditAttributeValue.Validate: Boolean;
var
  validationErrors: TValidationErrorSet;
  validationError: TValidationError;
  theId: Integer;
  errMsg: string;
begin
  if FEditMode = Add then
    theId := -1
  else
    theId := Integer(TCrudUtils.GetIdFromObject(
      FDataSet.Connection.Model.DefaultSchema.FindEntityType(FDataSet.EntitySetName),
      FDataSet.CurrentData
    ));

  Result := FValidator.Validate(theId, AttributeSelector.Value, AttributesValueEdit.Text, {o}validationErrors);

  if Result then
  begin
    ValidationsLabel.Visible := False;
    SetEditMode(None);
  end
  else
  begin
    ValidationsLabel.Visible := True;
    errMsg := 'There were errors when trying to save: ';
    for validationError in validationErrors do
      errMsg := errMsg + sLineBreak + FValidator.GetValidationErrorDesc(validationError, AttributeSelector.Value, AttributesValueEdit.Text);

    ValidationsLabel.Caption := errMsg;
    AttributesValueEdit.SetFocus;
  end;
end;

procedure TEditAttributeValue.WebFormCreate(Sender: TObject);
begin
  inherited;
  ValidationsLabel.Visible := False;
  AttributesValueEdit.Enabled := False;
  AttributeSelector.Enabled := False;
end;

procedure TEditAttributeValue.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ValidationsLabel := TLabel.Create('essentials.attributes.validations.label');
  AttributeSelector := TDBLookupComboBox.Create('essentials.attribute.selector');
  AttributesValueEdit := TDBEdit.Create('essentials.attribute.value.edit');

  TitleBarLabel.BeforeLoadDFMValues;
  ValidationsLabel.BeforeLoadDFMValues;
  AttributeSelector.BeforeLoadDFMValues;
  AttributesValueEdit.BeforeLoadDFMValues;
  try
    Height := 241;
    Caption := 'EditAttributeValue';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 70;
    TitleBarLabel.Caption := 'Edit Attribute';
    ValidationsLabel.SetParentComponent(Self);
    ValidationsLabel.Name := 'ValidationsLabel';
    ValidationsLabel.Left := 210;
    ValidationsLabel.Top := 136;
    ValidationsLabel.Width := 71;
    ValidationsLabel.Height := 15;
    ValidationsLabel.Caption := 'ErrorMessage';
    ValidationsLabel.ElementClassName := 'is-invalid';
    ValidationsLabel.HeightPercent := 100.000000000000000000;
    ValidationsLabel.WidthPercent := 100.000000000000000000;
    AttributeSelector.SetParentComponent(Self);
    AttributeSelector.Name := 'AttributeSelector';
    AttributeSelector.Left := 89;
    AttributeSelector.Top := 92;
    AttributeSelector.Width := 161;
    AttributeSelector.Height := 22;
    AttributeSelector.ElementClassName := 'form-select';
    AttributeSelector.ElementFont := efCSS;
    AttributeSelector.HeightPercent := 100.000000000000000000;
    AttributeSelector.WidthPercent := 100.000000000000000000;
    SetEvent(AttributeSelector, Self, 'OnChange', 'AttributeSelectorChange');
    AttributeSelector.DataField := 'AttributeId';
    AttributeSelector.DataSource := DataSource;
    AttributeSelector.KeyField := 'Id';
    AttributeSelector.ListField := 'Name';
    AttributesValueEdit.SetParentComponent(Self);
    AttributesValueEdit.Name := 'AttributesValueEdit';
    AttributesValueEdit.Left := 256;
    AttributesValueEdit.Top := 92;
    AttributesValueEdit.Width := 249;
    AttributesValueEdit.Height := 22;
    AttributesValueEdit.ChildOrder := 4;
    AttributesValueEdit.ElementClassName := 'form-control';
    AttributesValueEdit.ElementFont := efCSS;
    AttributesValueEdit.ElementPosition := epIgnore;
    AttributesValueEdit.HeightStyle := ssAuto;
    AttributesValueEdit.HeightPercent := 100.000000000000000000;
    AttributesValueEdit.Text := 'AttributesValueEdit';
    AttributesValueEdit.WidthStyle := ssAuto;
    AttributesValueEdit.WidthPercent := 100.000000000000000000;
    AttributesValueEdit.DataField := 'DataValue';
    AttributesValueEdit.DataSource := DataSource;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    ValidationsLabel.AfterLoadDFMValues;
    AttributeSelector.AfterLoadDFMValues;
    AttributesValueEdit.AfterLoadDFMValues;
  end;
end;

end.
